import React from 'react';
import Button from '../Button/Button';
import Label from '../Label/Label';

import styles from './LabeledButton.module.css';

const LabeledButton = ({ onClick, disabled, label, buttonText, buttonTooltip, tooltipText }) => {
    return (
        <React.Fragment>
            <Label value={label} tooltip={buttonTooltip} />
            <Button disabled={disabled} onClick={onClick} className={styles.button} tooltipText={tooltipText}>
                {buttonText}
            </Button>
        </React.Fragment>
    );
};

export default React.memo(LabeledButton);
